import * as React from "react";
import { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
const CollapsibleContent = styled(Col)`
  max-height: ${({ $maxHeight }) => $maxHeight};
  overflow: hidden;
  transition: max-height 0.3s ease-out;
`;
const TitleRow = styled(Row)`
  cursor: pointer;
  padding: ${({ theme }) => theme.spacings.sm};
  border-radius: 8px;
  background-color: ${({ theme, $expanded }) => $expanded ? theme.colors.background.secondaryNav : "transparent"};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.secondaryNav};
  }
`;
const Arrow = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${({ $expanded }) => $expanded ? "-180" : "0"}deg);
  transition: transform 0.3s ease-out;
  margin-left: auto;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
function Collapsible({ title = void 0, disabled = false, expanded = false, children }) {
  const ref = useRef(null);
  const [show, setShow] = useState(expanded);
  const [maxHeight, setMaxHeight] = useState("0");
  const onClick = (e) => {
    if (disabled) return;
    if (e.target.tagName !== "INPUT") setShow(!show);
  };
  useEffect(() => {
    if (show) {
      setMaxHeight(`${ref.current.scrollHeight}px`);
      setTimeout(() => setMaxHeight("fit-content"), 400);
    } else {
      if (maxHeight === "fit-content") setMaxHeight(`${ref.current.scrollHeight}px`);
      setTimeout(() => setMaxHeight("0"), 400);
    }
  }, [maxHeight, show]);
  return /* @__PURE__ */ React.createElement(Col, { $width: "100%", $gap: "0.3rem" }, /* @__PURE__ */ React.createElement(
    TitleRow,
    {
      $align: "center",
      $justify: "space-between",
      $width: "100%",
      onClick,
      $expanded: show,
      role: "rowheader",
      "aria-label": "collapsible trigger"
    },
    title,
    !disabled && /* @__PURE__ */ React.createElement(
      Arrow,
      {
        title: "toggle details",
        name: disabled ? "unknown_med" : "keyboard_arrow_down",
        type: "regular",
        $expanded: show
      }
    )
  ), /* @__PURE__ */ React.createElement(
    CollapsibleContent,
    {
      ref,
      $maxHeight: maxHeight,
      $width: "100%",
      role: "contentinfo",
      "aria-label": "collapsible body"
    },
    show && children
  ));
}
export default Collapsible;
